<template>
    <tr v-if="printArticle">
      <td>{{ (inEnglish) ? print.name_en : print.name }}</td>
      <td>
        <span class="text-primary cursor--pointer" @click="show">
          <i class="fa fa-info-circle"></i> {{ (inEnglish) ? printArticle.name_en : printArticle.name }}
        </span>
      </td>
      <td class="print-article__table__row-price">
        {{ $filters.formatMoney(printArticle.price) }}
      </td>
      <td>
        <div v-if="printArticle.pivot.bookable" class="input-group input-group-sm print__input-group">
          <span class="input-group-btn">
            <button
              class="btn btn-primary btn-sm"
              tabindex="-1"
              type="button"
              :disabled="printArticle.count <= printArticle.inclusive"
              @click.prevent="decreasePrintArticleCount"
            >
              <i class="fa fa-minus" aria-hidden="true"></i>
            </button>
          </span>
          <input
              class="form-control"
              type="number"
              :step="1"
              :min="printArticle.inclusive"
              :max="printArticle.count"
              name="depth"
              v-model="printArticle.count"
              @blur="updateBasket(printArticle)"
          >
          <span class="input-group-btn">
            <button
              class="btn btn-primary btn-sm"
              tabindex="-1"
              type="button"
              :disabled="printArticle.count >= maxCount"
              @click.prevent="increasePrintArticleCount"
            >
              <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
          </span>
        </div>

        <div v-else>
          {{ $t('article_not_available') }}
        </div>
      </td>
      <td class="text-right print-article__table__row-price">
        {{ $filters.formatMoney(printArticle.count * printArticle.price) }}
      </td>
    </tr>
</template>
<script setup>
import { computed } from 'vue';
import { useMainStore } from '@/store'
import { addLateDeliverySurcharge } from '@/utils/helper'

const store = useMainStore()

const props = defineProps({
    print: {
        type: Object,
        required: true,
    },
    article: {
        type: Object,
        required: true,
    }
});

// Emits
const emit = defineEmits(['show'])

// Computes
const locale = computed(() => store.settings.locale)
const inEnglish = computed(() => locale.value === 'en')
const shoppingCart = computed(() => store.settings.shopping_cart)
const maxCount = computed(() => props.article.count)
const printArticle = computed(() => {
  return shoppingCart.value.print_items.find((item) => {
    return item.parent_id === props.article.id && item.id === props.print.print_article_id && props.print.id === item.article_print_id
  })
})

// Methods
const increasePrintArticleCount = () => {
    if (printArticle.value.count < maxCount.value) {
        printArticle.value.count += 1;
    }
}
const decreasePrintArticleCount = () => {
    if (printArticle.value.count > printArticle.value.inclusive) {
        printArticle.value.count -= 1;
    }
}

const show = () => {
  emit('show', printArticle.value)
}
</script>